import { useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { useSelector } from "react-redux";

// Define algorithm constants
export const ALGORITHMS = {
    RELATIVE_WEIGHT_ANALYSIS: {
        value: "relative_weight_analysis",
        label: "Relative Weight Analysis",
    },
    PARTIAL_LEAST_SQUARES: {
        value: "partial_least_squares",
        label: "Partial Least Squares",
    },
    RANDOM_FOREST_CLASSIFIER: {
        value: "random_forest_classifier",
        label: "Random Forest Classifiers",
    },
};

const DriverAnalysisMethodDropdown = ({ selectedAlgorithm, onAlgorithmChange, placeholder = "Select Driver Analysis Method", width = "100%", margin = "15px 0 20px 0", className = "dropdown" }) => {
    // Get product category
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    // Determine if Beauty and Wellbeing category (Hair Care or Skin Care)
    const isBeautyAndWellbeing = isHairCare || isSkinCare;

    // Algorithm dropdown options
    const algorithmDropdownData = [ALGORITHMS.RELATIVE_WEIGHT_ANALYSIS, ALGORITHMS.PARTIAL_LEAST_SQUARES, ALGORITHMS.RANDOM_FOREST_CLASSIFIER];

    // Default selection for Beauty & Wellbeing
    useEffect(() => {
        if ((isBeautyAndWellbeing || isUnileverFragranceHouse) && !selectedAlgorithm) {
            onAlgorithmChange(ALGORITHMS.PARTIAL_LEAST_SQUARES);
        }
    }, [isBeautyAndWellbeing, isUnileverFragranceHouse, selectedAlgorithm, onAlgorithmChange]);

    // For non-Beauty & Wellbeing categories - don't show anything
    if (!(isBeautyAndWellbeing || isUnileverFragranceHouse)) {
        return null;
    }

    return (
        <div style={{ margin: margin, width: width }}>
            <Select
                className={className}
                name="driverAnalysisMethod"
                placeholder={placeholder}
                onChange={onAlgorithmChange}
                value={selectedAlgorithm}
                options={algorithmDropdownData}
                styles={{
                    control: (base) => ({
                        ...base,
                        fontSize: "14px",
                        minHeight: "40px",
                    }),
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        </div>
    );
};

DriverAnalysisMethodDropdown.propTypes = {
    selectedAlgorithm: PropTypes.object,
    onAlgorithmChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    width: PropTypes.string,
    margin: PropTypes.string,
    className: PropTypes.string,
};

export default DriverAnalysisMethodDropdown;
